function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
var MaterialSelectDirective = /*#__PURE__*/function () {
  function MaterialSelectDirective($log, $timeout) {
    var _this = this;
    _classCallCheck(this, MaterialSelectDirective);
    _defineProperty(this, "require", 'ngModel');
    _defineProperty(this, "link", function (scope, $element, attrs, ctrls) {
      var instance = {
        selectInstance: null
      };
      _this.$log.info('==== attr', attrs);
      scope.$watch(attrs.ngModel, function (newVal, oldVal) {
        _this.$log.info('==', newVal, scope, $element, ctrls);
        var _instance = _this._initInstance($element, instance);
        if (!newVal) {
          // limpia el model
          _instance && (_instance.input.value = '');
        }
      });
      _this.$timeout(function () {
        return $element.formSelect();
      }, 100);
    });
    this.$log = $log;
    this.$timeout = $timeout;
  }
  return _createClass(MaterialSelectDirective, [{
    key: "_initInstance",
    value: function _initInstance($element, instance) {
      if (!instance.selectInstance) instance.selectInstance = M.FormSelect.getInstance($element[0]);
      return instance.selectInstance;
    }
  }]);
}();
angular.module('candidato').directive('materialSelectCaxton', ["$log", "$timeout", function ($log, $timeout) {
  return new MaterialSelectDirective($log, $timeout);
}]);